import makeFetch from "../../utils/http";

export function api_getPetsList(params) {
    return makeFetch(
        "animals",
        "GET",
        params
    );
}
export function api_setHelpfulAnswer(body) {
    return makeFetch(
        "animalQuestionnaires",
        "POST",
        {},
        JSON.stringify(body)
    );
}
export function api_setAnimal(body) {
    return makeFetch(
        "animals",
        "POST",
        {},
        JSON.stringify(body)
    );
}

export function api_deleteAnimal(id) {
    return makeFetch(
        `animals/${id}`,
        "DELETE",
    );
}

export function api_editAnimal(id, body) {
    return makeFetch(
        `animals/${id}`,
        "PATCH",
        {},
        JSON.stringify(body)
    );
}

export function api_createAnimal(body) {
    return makeFetch(
        "animals",
        "POST",
        {},
        JSON.stringify(body)
    );
}

export function api_getPetURLUploadImage(id) {
    return makeFetch(
        `animals/${id}/upload`,
        "GET"
    );
}

export function api_getPetByID(id) {
    return makeFetch(
        `animals/${id}`,
        "GET"
    );
}

export function api_getNotesForPet(id) {
    return makeFetch(
        "appointmentnotes",
        "GET",
        {animalId: id}
    );
}
